var carrousel_accueil;

$(document).ready(function() {
	if ($('#carrousel_accueil').length > 0) {
		carrousel_accueil = $('#carrousel_accueil');
		carrousel_accueil.owlCarousel({
			loop: true,
			items: 1,
			margin: 0,
			lazyLoad: true,
			video: true,
			autoplay: true,
			autoplayTimeout: 5000,
			autoplayHoverPause: true
		});
	}

	$('#famille').on('change', function() {
		var famille = $(this).val();
		var marque = $('#marque').val();

		if (famille || marque) {
			$('#quick_search .error').hide();
		}

		$.ajax({
			url : lang_path + '/index/marques/index.html',
			type : 'GET',
			data : {
				'menuitems_id' : famille
			},
			success : function(data) {
				$('#marque').empty();
				$('#marque').append(data);

				if ($('#marque option[value="' + marque + '"]').length > 0) {
					$('#marque').val(marque);
				}
			}
		});
	});

	$('#marque').on('change', function() {
		var marque = $(this).val();
		var famille = $('#famille').val();

		if (famille || marque) {
			$('#quick_search .error').hide();
		}

		$.ajax({
			url : lang_path + '/index/familles/index.html',
			type : 'GET',
			data : {
				'marques_id' : marque
			},
			success : function(data) {
				$('#famille').empty();
				$('#famille').append(data);

				if ($('#famille option[value="' + famille + '"]').length > 0) {
					$('#famille').val(famille);
				}
			}
		});
	});

	$('#quick_search').on('submit', function(e) {
		e.preventDefault();

		var marque = $('#marque').val();
		var marque_lien = $('#marque').find('option:selected').data('lien');
		var famille = $('#famille').val();
		var famille_lien = $('#famille').find('option:selected').data('lien');

		if (marque && famille) {
			var url = marque_lien + '#accordeon_' + famille;
		} else if (famille) {
			var url = famille_lien;
		} else if (marque) {
			var url = marque_lien;
		} else {
			$('#quick_search .error').show();
			return false;
		}
//console.log(url);

		window.location.href = url;
	});

	// Gestion du scroll
	//var lastScrollTop = $(window).scrollTop();
	//var nowScrollTop = $(window).scrollTop();
	//update_scroll();
	//$(window).scroll(debounce(update_scroll, 16));
});

function update_scroll() {
	//console.log('update_scroll');
	nowScrollTop = $(window).scrollTop();
	/*if (nowScrollTop > lastScrollTop) {
		console.log('scroll down');
	} else if (nowScrollTop < lastScrollTop) {
		console.log('scroll up');
	} else {
		console.log('no scroll');
	}*/

	update_logo_size();

	lastScrollTop = nowScrollTop;
}

function update_logo_size() {
	if (nowScrollTop > 100) {
		$('.header .logo').addClass('resize');
	} else if (nowScrollTop > 0 && nowScrollTop < 100) {
		if (nowScrollTop > lastScrollTop) {
			$('.header .logo').addClass('resize');
		} else {
			$('.header .logo').removeClass('resize');
		}
	} else {
		$('.header .logo').removeClass('resize');
	}
}
